var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validacion",class:[_vm.isForResponsive],attrs:{"id":"GButton"},on:{"click":_vm.doLogin}},[_c('span',[_vm._v("LOGIN CON Google")]),_c('img',{staticStyle:{"width":"15px","margin-left":"10px"},attrs:{"src":_vm.google}})])
}
var staticRenderFns = []

export { render, staticRenderFns }